import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import '../styles/DraftList.css';

function DraftList({ drafts, onSelectDraft, draftCount }) {
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'P0':
        return '#e74c3c';
      case 'P1':
        return '#f39c12';
      case 'P2':
        return '#3498db';
      default:
        return '#95a5a6';
    }
  };

  const getChannelIcon = (channel) => {
    switch (channel) {
      case 'email':
        return '✉️';
      case 'whatsapp':
        return '💬';
      case 'linkedin':
        return '🔗';
      case 'telegram':
        return '📱';
      default:
        return '💌';
    }
  };

  return (
    <div className="draft-list">
      <div className="list-header">
        <h2>Pending Drafts ({draftCount})</h2>
        <p className="list-hint">Click a draft to review and approve</p>
      </div>

      <div className="drafts-container">
        {drafts.map((draft) => (
          <div
            key={draft.id}
            className="draft-card"
            onClick={() => onSelectDraft(draft)}
            role="button"
            tabIndex={0}
          >
            <div className="draft-card-priority">
              <span
                className="priority-badge"
                style={{ backgroundColor: getPriorityColor(draft.priority) }}
              >
                {draft.priority || 'P2'}
              </span>
            </div>

            <div className="draft-card-content">
              <div className="draft-card-header">
                <div className="contact-info">
                  <h3 className="contact-name">{draft.contact_name}</h3>
                  <p className="contact-company">{draft.company}</p>
                </div>
                <div className="channel-badge">
                  {getChannelIcon(draft.channel)} {draft.channel}
                </div>
              </div>

              <div className="draft-card-body">
                <p className="draft-snippet">
                  {draft.body.substring(0, 120)}
                  {draft.body.length > 120 ? '...' : ''}
                </p>
              </div>

              <div className="draft-card-footer">
                <span className="timestamp">
                  {formatDistanceToNow(new Date(draft.created_ts), { addSuffix: true })}
                </span>
                <span className="message-count">
                  {draft.message_count} {draft.message_count === 1 ? 'message' : 'messages'}
                </span>
              </div>
            </div>

            <div className="draft-card-arrow">→</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DraftList;
